import React from 'react';
import './Footer.css'
import '../Navbar/Navbar.css'
import { AiFillGithub, AiFillLinkedin, AiFillYoutube } from 'react-icons/ai';
import { FaDiscord } from 'react-icons/fa';


const Footer = () => {
    return (
        <section className="footer">
                <div className="container ">
                    <div class="footerIcon">
                        <AiFillGithub className="footerIcons mr-3" />
                        <FaDiscord className="footerIcons mr-3" />
                        <AiFillLinkedin className="footerIcons mr-3" />
                        <AiFillYoutube className="footerIcons mr-3" />
                    </div>
                    <div class="mt-3 footerText ">
                        <p>Designed and Developed by <a target="_blank" title="Github" href="https://github.com/sajjadsadiqofficial">Sajjad Sadiq</a></p>
                        <p>Copyright © 2021, All Rights Reserved</p>
                    </div>
                </div>
        </section>
    );
};

export default Footer;